import getOrderEstimate from "./getOrderEstimate";
import saveDefaultAddress from "./saveDefaultAddress";
import {
  getFromSessionStorage,
  saveToSessionStorage,
} from "@/utils/sessionStorageUtils";
import { saveToLocalStorage } from "@/utils/localStorageUtils";
import { LocalStorageKey, SessionStorageKey } from "@/utils/storageKeys";
import { ScheduledTime } from "@/dto/scheduledTime";
import { OrderType } from "@/constants/enum";
import { Address } from "@/dto/address";

export const onDeliveryAddressUpdate = async (
  address: Address,
  isDefaultDelivery: boolean,
  merchantId: string,
  dependencies: {
    openCartDrawer: () => void;
    setDeliveryAddressModalOpen: (value: boolean) => void;
    setDeliveryAddressErrorModalOpen: (value: boolean) => void;
  }
) => {
  const {
    openCartDrawer,
    setDeliveryAddressModalOpen,
    setDeliveryAddressErrorModalOpen,
  } = dependencies;
  try {
    const result = await getOrderEstimate(merchantId, address);
    if (isDefaultDelivery) {
      await saveDefaultAddress(address);
    }
    saveToSessionStorage(SessionStorageKey.ORDER_ESTIMATES, result);
    saveToLocalStorage(LocalStorageKey.DELIVERY_ADDRESS, address);
    const sessionTime = getFromSessionStorage<Partial<ScheduledTime>>(
      SessionStorageKey.SCHEDULED_TIME,
      {}
    );
    /**
     * On changing delivery address when order type is already delivery,
     * session time need to be re calculated on opening the cart.
     * In restaurantCartUtils -> calculatePickupTime, there is a check
     * if orderType selected and orderType stored in session are same then skip recalculation
     * Hence here deleting the session time so it re calculates though order type is same
     */
    if (sessionTime && sessionTime.orderType === OrderType.DELIVERY) {
      const newSessionTime = {
        orderType: OrderType.DELIVERY,
      };
      saveToSessionStorage(SessionStorageKey.SCHEDULED_TIME, newSessionTime);
    }
    /**
     * On updating delivery address, cart should be opened
     */
    openCartDrawer();
    setDeliveryAddressModalOpen(false);
  } catch {
    setDeliveryAddressModalOpen(false);
    setDeliveryAddressErrorModalOpen(true);
  }
};
